var main = [{
  id: 'Voor wie',
  title: 'Voor wie',
  to: '/over-sdu/producten-diensten',
  children: [{
    title: 'Vakgebied',
    children: [{
      id: 'Advocaten en juristen',
      title: 'Advocaten en juristen',
      to: '/advocaten-juristen'
    }, {
      id: 'Compliance officers',
      title: 'Compliance officers',
      to: '/over-sdu/compliance-officers'
    }, {
      id: 'Docenten',
      title: 'Docenten',
      to: '/over-sdu/voor-docenten'
    }, {
      id: 'Douane professionals',
      title: 'Douane professionals',
      to: '/bedrijfsvoering/douane'
    }, {
      id: 'ESG-professionals',
      title: 'ESG-professionals',
      to: '/jes/esg-csrd-management'
    }, {
      id: 'Fiscalisten en accountants',
      title: 'Fiscalisten en accountants',
      to: '/fiscaal/fiscalisten-accountants'
    }]
  }, {
    title: 'Vakgebied',
    children: [{
      id: 'Gemeenten',
      title: 'Gemeenten',
      to: '/overheid/producten-diensten/vind/vind-gemeenten'
    }, {
      id: 'HSE-professionals',
      title: 'HSE-professionals',
      to: '/bedrijfsvoering/producten-diensten/hse'
    }, {
      id: 'Notarissen',
      title: 'Notarissen',
      to: '/over-sdu/notarissen'
    }, {
      id: 'OR-leden',
      title: 'OR-leden',
      to: '/bedrijfsvoering/ondernemingsraad'
    }, {
      id: 'Studenten',
      title: 'Studenten',
      to: '/over-sdu/studenten'
    }]
  }, {
    title: 'Branche',
    children: [{
      id: 'Bedrijfsleven',
      title: 'Bedrijfsleven',
      to: '/bedrijfsvoering'
    }, {
      id: 'Fiscaal & Accountancy',
      title: 'Fiscaal & Accountancy',
      to: '/fiscaal'
    }, {
      id: 'Juridisch',
      title: 'Juridisch',
      to: '/juridisch'
    }, {
      id: 'Onderwijs',
      title: 'Onderwijs',
      to: '/overheid/producten-diensten/vind/vind-onderwijs'
    }, {
      id: 'Overheid',
      title: 'Overheid',
      to: '/overheid'
    }, {
      id: 'Woningcorporaties',
      title: 'Woningcorporaties',
      to: '/overheid/producten-diensten/vind/vind-woningcorporaties'
    }]
  }]
}, {
  id: 'Oplossingen',
  title: 'Oplossingen',
  to: '/over-sdu/producten-diensten',
  children: [{
    title: 'Software',
    children: [{
      id: 'ESG adviesflow',
      title: 'ESG adviesflow',
      to: '/jes/producten/jes-workflow'
    }, {
      id: 'Fiscale adviesflow',
      title: 'Fiscale adviesflow',
      to: '/fiscaal/producten-diensten/taxvice'
    }, {
      id: 'Gemeentelijke dienstverlening',
      title: 'Gemeentelijke dienstverlening',
      to: '/overheid/producten-diensten/vind-producten'
    }, {
      id: 'Notarieel softwaresysteem',
      title: 'Notarieel softwaresysteem',
      to: '/juridisch/producten-diensten/notaflow'
    }, {
      id: 'Online aandeelhoudersregister',
      title: 'Online aandeelhoudersregister',
      to: '/juridisch/producten-diensten/evidend'
    }]
  }, {
    title: 'Research',
    children: [{
      id: 'Financial Law huB',
      title: 'Financial Law huB',
      to: '/juridisch/producten-diensten/opmaat/financial-law-hub'
    }, {
      id: 'NDFR',
      title: 'NDFR',
      to: '/fiscaal/producten-diensten/ndfr'
    }, {
      id: 'OpMaat',
      title: 'OpMaat',
      to: '/juridisch/producten-diensten/opmaat'
    }, {
      id: 'Rechtsorde',
      title: 'Rechtsorde',
      to: '/juridisch/producten-diensten/rechtsorde'
    }]
  }, {
    title: 'Kennisbanken',
    children: [{
      id: 'Fiscaal en meer',
      title: 'Fiscaal en meer',
      to: '/fiscaal/producten-diensten/fiscaal-en-meer'
    }, {
      id: 'HSE',
      title: 'HSE',
      to: '/bedrijfsvoering/producten-diensten/hse'
    }, {
      id: 'In- en Uitvoer',
      title: 'In- en Uitvoer',
      to: '/bedrijfsvoering/producten-diensten/inenuitvoer'
    }, {
      id: 'Inzicht in de OR',
      title: 'Inzicht in de OR',
      to: '/bedrijfsvoering/producten-diensten/inzicht-in-de-or'
    }, {
      id: 'VIND Kennisbanken',
      title: 'VIND Kennisbanken',
      to: '/overheid/producten-diensten/vind/vind-kennisbanken'
    }]
  }]
}, {
  id: 'Kennis',
  title: 'Kennis',
  to: '/over-sdu/whitepapers',
  children: [{
    title: 'Kennis',
    children: [{
      id: 'Opleidingen',
      title: 'Opleidingen',
      to: '/over-sdu/producten-diensten/events-opleidingen'
    }, {
      id: 'Whitepapers',
      title: 'Whitepapers',
      to: '/over-sdu/whitepapers'
    }, {
      id: 'Podcasts',
      title: 'Podcasts',
      to: '/over-sdu/podcasts'
    }, {
      id: 'Webinars',
      title: 'Webinars',
      to: '/over-sdu/webinars'
    }, {
      id: 'Blog',
      title: 'Blog',
      to: 'https://www.sdu.nl/blog.html'
    }]
  }, {
    title: 'Service',
    children: [{
      id: 'Producttrainingen',
      title: 'Producttrainingen',
      to: '/service/onlineproducttrainingen'
    }, {
      id: 'Product inloggen',
      title: 'Product inloggen',
      to: '/product-login'
    }, {
      id: 'Nieuwsbrieven',
      title: 'Nieuwsbrieven',
      to: '/service/nieuwsbrieven-gratis'
    }, {
      id: 'Veelgestelde vragen',
      title: 'Veelgestelde vragen',
      to: '/service'
    }]
  }, {
    title: 'Sdu nieuwssites',
    children: [{
      id: 'Advocatie',
      title: 'Advocatie',
      to: 'https://www.advocatie.nl/'
    }, {
      id: 'Gemeente.nu',
      title: 'Gemeente.nu',
      to: 'https://gemeente.nu/'
    }, {
      id: 'HSE Actueel',
      title: 'HSE Actueel',
      to: 'https://hseactueel.nl/'
    }, {
      id: 'Taxence',
      title: 'Taxence',
      to: 'https://www.taxence.nl/'
    }]
  }]
}, {
  id: 'Webshop',
  title: 'Webshop',
  to: 'https://www.sdu.nl/shop/alle-producten.html',
  children: [{
    title: 'Uitgelicht',
    children: [{
      id: 'Alle producten',
      title: 'Alle producten',
      to: 'https://www.sdu.nl/shop/alle-producten.html'
    }, {
      id: 'Nieuw',
      title: 'Nieuw',
      to: 'https://www.sdu.nl/shop/nieuw.html?product_list_dir=desc'
    }, {
      id: 'Best verkocht',
      title: 'Best verkocht',
      to: 'https://www.sdu.nl/shop/beststellers.html'
    }, {
      id: 'Studieboeken',
      title: 'Studieboeken',
      to: 'https://www.sdu.nl/shop/studieboeken.html'
    }, {
      id: 'Vaccinatieboekjes',
      title: 'Vaccinatieboekjes',
      to: 'https://www.sdu.nl/shop/het-vaccinatieboekje-internationaal-bewijs-van-inenting-3-talig-pak-50.html'
    }]
  }, {
    title: 'Categorieën',
    children: [{
      id: 'Jurisprudentie',
      title: 'Jurisprudentie',
      to: 'https://www.sdu.nl/shop/catalogsearch/result/?q=Jurisprudentie'
    }, {
      id: 'Commentaren',
      title: 'Commentaren',
      to: 'https://www.sdu.nl/shop/catalogsearch/result/?q=Commentaren'
    }, {
      id: 'Formulieren',
      title: 'Formulieren',
      to: '/over-sdu/producten-diensten/formulieren'
    }, {
      id: 'Tijdschriften',
      title: 'Tijdschriften',
      to: 'https://www.sdu.nl/shop/catalogsearch/result/?q=tijdschrift'
    }, {
      id: 'On demand opleidingen',
      title: 'On demand opleidingen',
      to: 'https://www.sdu.nl/shop/on-demands.html'
    }]
  }, {
    title: 'Online producten',
    children: [{
      id: 'Notamail',
      title: 'Notamail',
      to: 'https://www.sdu.nl/shop/notamail-online-dagelijkse-e-mail.html'
    }, {
      id: 'HSE',
      title: 'HSE',
      to: 'https://www.sdu.nl/shop/sdu-hse-online-arbo-praktijkinformatie-en-regelgeving.html'
    }, {
      id: 'Chemiekaarten',
      title: 'Chemiekaarten',
      to: 'https://www.sdu.nl/shop/chemiekaarten-online-abonnement.html'
    }, {
      id: 'NDFR',
      title: 'NDFR',
      to: 'https://www.sdu.nl/shop/alle-producten.html'
    }, {
      id: 'Alle abonnementen ',
      title: 'Alle abonnementen ',
      to: '/over-sdu/producten-diensten/abonnementen'
    }]
  }]
}];
var top = [{
  id: 'Werken bij',
  title: 'Werken bij',
  to: '/over-sdu/werken-bij'
}, {
  id: 'Klantenservice',
  title: 'Klantenservice',
  to: '/service'
}, {
  id: 'Over Sdu',
  title: 'Over Sdu',
  to: '/over-sdu'
}];

export { main, top };
//# sourceMappingURL=navigationData.js.map
